/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/

import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import useUsuario from 'hooks/useUsuario';
import React, { useEffect } from 'react';
import { consumirServicioEncirptacion } from '../../api';
import { ambienteAplicacion, urlResumenCotizadorMex } from 'constants/urls';
import Loading from '../../wrappers/Loading';
import { DO } from './constantes/general'

const RecuperarCotizacionDO = () => {
    const { addWarningToast } = useCustomToast();
    const usuario = useUsuario();
    const { id: idCotizacion } = useQueryParams();
    const history = useCustomRouter();

    const getData = async () => {
        const DataResumen = {
            cotDatos: {
                ambiente: ambienteAplicacion,
                cotCodigo: idCotizacion,
            },
            usuCotiza: { usuCodigo: usuario?.cliCodigoCore },
        };
        const resRecuperar = await consumirServicioEncirptacion(
            urlResumenCotizadorMex,
            DataResumen,
        );
       
        if (resRecuperar.transaccion) {
            if (resRecuperar?.cotConsulta?.redireccionar === true) {
                switch (resRecuperar.cotConsulta.pasoCarrito) {
                    case 'Datos del seguro':
                        return history.push(`${DO.urls.datosAsegurado}?idCotizacion=${idCotizacion}`);
                    case 'Declaraciones':
                        return history.push(`${DO.urls.preguntas}?idCotizacion=${idCotizacion}`);
                    case 'Elige tu plan':
                        return history.push(`${DO.urls.planes}?idCotizacion=${idCotizacion}`);
                    case 'Opción de pago':
                        return history.push(`${DO.urls.resumen}?idCotizacion=${idCotizacion}`);
                    default:
                        return history.push(`${DO.urls.datosAsegurado}?idCotizacion=${idCotizacion}`);
                }
            }
            addWarningToast(resRecuperar?.cotConsulta?.mensajeRedireccion);
            return history.push('/');
        } else {
            addWarningToast('Ha ocurrido un problema al recuperar la cotización');
            history.goBack();
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <Loading loading={true} message="Recuperando...">
            <h1>Recuperando...</h1>
        </Loading>
    );
};
export default RecuperarCotizacionDO;
